"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useFormContext = _interopRequireDefault(require("../../../../hooks/useFormContext"));
var _react = require("react");
var _uuid = require("uuid");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var Custom = function Custom(props) {
  var involvedFieldNames = props.involvedFieldNames,
    validateOnChange = props.validateOnChange,
    validationFunction = props.validationFunction;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var _a = (0, _useFormContext.default)(),
    addFormValidation = _a.addFormValidation,
    removeFormValidation = _a.removeFormValidation;
  var validation = (0, _react.useCallback)(function (formData) {
    var validationMessages = validationFunction(formData);
    return validationMessages.map(function (validationMessage) {
      return __assign(__assign({}, validationMessage), {
        involvedFieldNames: Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], validationMessage.involvedFieldNames || [], true), involvedFieldNames, true), [validationMessage.fieldName], false)))
      });
    });
  }, [involvedFieldNames, validationFunction]);
  (0, _react.useEffect)(function () {
    addFormValidation("custom_form_" + uuid, involvedFieldNames, validation, validateOnChange);
    return function () {
      removeFormValidation("custom_form_" + uuid);
    };
  }, [addFormValidation, involvedFieldNames, removeFormValidation, uuid, validateOnChange, validation]);
  return null;
};
var _default = Custom;
exports.default = _default;